module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/adults-2f7170fd1e4ab0b783b479ac640b954b.webp";